export default "__VITE_ASSET__BSoLJpwB__"